export default __webpack_public_path__ + "static/media/avatar.dd41ff8a.jpg";